import React from "react";
import { Divider, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import FlexBox from "components/FlexBox/FlexBox";
import { IParticipantEntity } from "models/Participant.model";
import { css } from "@emotion/react";
import { initialsFromName } from "utils/initialsFromName";
import UserAvatar from "components/UserAvatar/UserAvatar";
import ParticipantCardDetail from "./ParticipantCardDetail";

type Props = {
  participant: IParticipantEntity;
  actions?: React.ReactNode;
};

const GroupParticipants: React.FC<Props> = ({ participant, actions }) => {
  const groupMembers = participant.groupList ? participant.groupList.split(", ") : [];

  return (
    <StyledWrapper data-testid={`ParticipantGroupList-${participant.id}`}>
      <StyledStack>
        <ParticipantCardDetail participant={participant} isShowAsIndividual={true} actions={actions} />
        <Divider />
        {groupMembers.map((groupName, index, arr) => (
          <div key={groupName + index}>
            <StyledCardDetailChildSection>
              <FlexBox alignSelf={"flex-start"}>
                <UserAvatar initials={initialsFromName(groupName)} rectSize={44} fontSize={16} />
              </FlexBox>
              <FlexBox flexShrink={1} spacing={2} direction={"column"}>
                <StyledChildParticipantHeader>{groupName}</StyledChildParticipantHeader>
              </FlexBox>
            </StyledCardDetailChildSection>
            {index < arr.length - 1 && <Divider />}
          </div>
        ))}
      </StyledStack>
    </StyledWrapper>
  );
};

const StyledWrapper = styled("div")(
  ({ theme }) => css`
    padding: 8px 24px 24px 24px;
    width: 100%;
    display: flex;
    align-self: flex-start;
    flex-direction: column;
    ${theme.mixins.flexGap("2px")}
  `
);

const StyledCardDetailChildSection = styled("div")(
  ({ theme }) => css`
    position: relative;
    display: flex;
    flex: 1;
    ${theme.mixins.flexGap("16px")}
    flex-direction: row;
    align-items: center;
    align-items: center;
    padding: 12px 16px;
  `
);

const StyledChildParticipantHeader = styled("span")(
  ({ theme }) => css`
    font-weight: 500;
    font-size: 16px;
    color: ${theme.palette.text.primary};
  `
);

const StyledStack = styled(Stack)(
  ({ theme }) => css`
    border: 1px solid ${theme.palette.background.default};
    border-radius: 4px;
    overflow: hidden;
  `
);

export default GroupParticipants;
